/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

interface Props {
    errors: Array<string>;
}

export default function ValidationErrors({errors}: Props) {
    return (
        <p>De volgende fouten zijn opgetreden:
            <ul style={{marginTop: '.5rem'}}>
                {errors.map((error: string) => <li>{error}</li>)}
            </ul>
        </p>
    )
}